import DateFnsUtils from "@date-io/date-fns";
import { DialogActions, FormControl, Grid, Icon } from "@material-ui/core";
import {
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import InputAdornment from "@material-ui/core/InputAdornment";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";
import { InlineDatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  SelectValidator,
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { connect } from "react-redux";

import Dialog from "../../components/Dialog";
import datetimeHelper from "../../helper/datetime-helper";
import { globalHistory } from "../../history";
import { mapActionsToProps } from "../../redux/miniCrm/contact";
import { mapActionsToProps as indastryAction } from "../../redux/miniCrm/indastry";
import { mapActionsToProps as stageAction } from "./../../redux/miniCrm/stage";

class CreateContact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      firstName: "",
      jobTitle: "",
      address: "",
      phoneNumber: "",
      email: "",
      gender: "",
      organization: "",
      from: new Date(),
      to: new Date(),
      note: "",
      birthday: new Date(),
      campaignList: [],
    };
  }

  componentDidMount() {
    this.history = globalHistory();
    this.props.getListStage();
    this.props.getListIndastry();
    this.unlisten = this.history.listen(() => {
      this.getDetail();
    });
    this.getDetail();
  }

  getDetail = () => {
    const id = this.props.match.params.id;
    this.props.getContactDetail(id);
  };

  componentWillUnmount() {
    this.unlisten();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.contact != this.props.contact) {
      const {
        id,
        title,
        firstName,
        jobTitle,
        address,
        phoneNumber,
        email,
        gender,
        organization,
        lastName,
        dob,
        industryId,
        stageId,
        note,
        social,
        website,
        idNumber,
        sourceId,
        campaignList,
        birthday,
      } = this.props.contact;
      this.setState({
        id,
        title,
        firstName,
        jobTitle,
        address,
        phoneNumber,
        email,
        gender,
        organization,
        lastName,
        dob,
        industryId,
        stageId,
        note,
        social,
        website,
        idNumber,
        sourceId,
        campaignList,
        birthday,
      });
    }
  }

  handleChange = (name) => {
    return (e) => {
      this.setState({
        [name]: e.target.value,
      });
    };
  };

  handleDateChangeBirthday = (date) => {
    this.setState({ birthday: datetimeHelper.toFormat(date, "YYYY-MM-DD") });
  };

  handleDateChangeEnd = (date) => {
    this.setState({ to: datetimeHelper.toFormat(date, "YYYY-MM-DD") });
  };

  handleSubmit = () => {
    const {
      id,
      title,
      firstName,
      jobTitle,
      address,
      phoneNumber,
      email,
      gender,
      organization,
      lastName,
      birthday,
      industryId,
      stageId,
      note,
      social,
      website,
      idNumber,
      sourceId,
    } = this.state;
    if (!id) {
      this.props.addNewContact(
        title,
        firstName,
        jobTitle,
        address,
        phoneNumber,
        email,
        gender,
        organization,
        lastName,
        birthday,
        industryId,
        stageId,
        note,
        social,
        website,
        idNumber
      );
    } else {
      this.props.editContact(
        id,
        title,
        firstName,
        jobTitle,
        address,
        phoneNumber,
        email,
        gender,
        organization,
        lastName,
        birthday,
        industryId,
        stageId,
        note,
        social,
        website,
        idNumber,
        sourceId
      );
    }
  };

  render() {
    const { classes, listIndastry, listStage, contact } = this.props;
    const {
      title,
      firstName,
      jobTitle,
      address,
      phoneNumber,
      email,
      gender,
      organization,
      lastName,
      birthday,
      industryId,
      stageId,
      note,
      social,
      website,
      idNumber,
      campaignList,
    } = this.state;
    const listIndastryResult =
      typeof listIndastry === "object"
        ? Object.keys(listIndastry).map((key) => listIndastry[key])
        : listIndastry;
    const listStageResult =
      typeof listStage === "object"
        ? Object.keys(listStage).map((key) => listStage[key])
        : listStage;
    return (
      <Paper className={classes.root}>
        <Toolbar className={classes.toolbar}>
          <span className={classes.breadCrumb}>
            <Button
              size="small"
              disableRipple={true}
              onClick={() =>
                this.history.push(
                  `${process.env.REACT_APP_PATH}/contact-center/contact`
                )
              }>
              <ArrowBackIos color="primary" />
              Danh sách danh bạ
            </Button>
          </span>
          <div style={{ flexGrow: 1 }}></div>
        </Toolbar>

        <div style={{ overflowX: "auto" }}>
          <ValidatorForm
            ref="form"
            onSubmit={this.handleSubmit}
            onError={(errors) => console.log(errors)}
            className={classes.form}>
            <FormControl className={classes.form}>
              <Grid container className={classes.grid}>
                <Grid item md={3}>
                  <SelectValidator
                    id="outlined-full-width"
                    margin="normal"
                    select
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu,
                        shrink: true,
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Trạng thái"
                    autoFocus={true}
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChange("stageId")}
                    value={stageId}
                    name="stageId">
                    {listStageResult
                      ? listStageResult.map((item) => {
                          return (
                            <MenuItem key={item.id} value={item.id}>
                              {item.name}
                            </MenuItem>
                          );
                        })
                      : null}
                  </SelectValidator>
                </Grid>
              </Grid>
              <Grid container className={classes.grid}>
                <Grid item md={3}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Danh xưng"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChange("title")}
                    value={title}
                    name="title"
                  />
                </Grid>
                <Grid item md={3}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Tên khách hàng *"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChange("firstName")}
                    value={firstName}
                    name="firstName"
                    validators={["required"]}
                    errorMessages={"Không được để trống"}
                  />
                </Grid>
                <Grid item md={3}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Họ"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChange("lastName")}
                    value={lastName || ""}
                    name="lastName"
                  />
                </Grid>
                <Grid item md={3}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <InlineDatePicker
                      margin="normal"
                      label="Ngày sinh"
                      variant="outlined"
                      className={classes.input}
                      value={birthday}
                      maxDate={new Date()}
                      format="dd/MM/yyyy"
                      onChange={this.handleDateChangeBirthday}
                      name="birthday"
                      validators={["required"]}
                      emptyLabel="Không được để trống"
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
              </Grid>
              <Grid container className={classes.grid}>
                <Grid item md={3}>
                  <SelectValidator
                    id="outlined-full-width"
                    margin="normal"
                    select
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu,
                        shrink: true,
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Giới tính"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChange("gender")}
                    value={gender}
                    name="gender">
                    <MenuItem key={"male"} value={"male"}>
                      Nam
                    </MenuItem>
                    <MenuItem key={"female"} value={"female"}>
                      Nữ
                    </MenuItem>
                  </SelectValidator>
                </Grid>
                <Grid item md={3}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Số chứng minh nhân dân"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChange("idNumber")}
                    value={idNumber || ""}
                    name="idNumber"
                    type="number"
                  />
                </Grid>
                <Grid item md={3}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Chức vụ"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChange("jobTitle")}
                    value={jobTitle}
                    name="jobTitle"
                  />
                </Grid>
                {/* <Grid item md={3}>
                                    <TextValidator
                                        id="outlined-full-width"
                                        margin="normal"
                                        label="Nguồn danh bạ"
                                        variant="outlined"
                                        className={classes.input}
                                        onChange={this.handleChange("jobTitle")}
                                        value={jobTitle}
                                        name="jobTitle"

                                    />
                                </Grid> */}
                <Grid item md={3}>
                  <SelectValidator
                    id="outlined-full-width"
                    margin="normal"
                    select
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu,
                        shrink: true,
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Nghề nghiệp"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChange("industryId")}
                    value={industryId}
                    name="industryId">
                    {listIndastryResult
                      ? listIndastryResult.map((item) => {
                          return (
                            <MenuItem key={item.id} value={item.id}>
                              {item.name}
                            </MenuItem>
                          );
                        })
                      : null}
                  </SelectValidator>
                </Grid>
              </Grid>
              <Grid container className={classes.grid}>
                <Grid item md={6}></Grid>
                <Grid item md={6}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Công ty"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChange("organization")}
                    value={organization}
                    name="organization"
                  />
                </Grid>
              </Grid>
              <Grid container className={classes.grid}>
                <Grid item md={6}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Điện thoại"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChange("phoneNumber")}
                    value={phoneNumber}
                    name="phoneNumber"
                    type="number"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Icon>phone</Icon>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Email"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChange("email")}
                    value={email}
                    name="email"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Icon>email</Icon>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Mạng xã hội"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChange("social")}
                    value={social}
                    name="social"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Icon>cloud_queue</Icon>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Website"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChange("website")}
                    value={website}
                    name="website"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Icon>public</Icon>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Địa chỉ"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChange("address")}
                    value={address}
                    name="address"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Icon>location_on</Icon>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item md={6}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Thông tin thêm"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChange("note")}
                    value={note}
                    name="note"
                    multiline
                    rows={8}
                  />
                  <Typography
                    variant="h6"
                    gutterBottom
                    style={{ marginTop: 10 }}>
                    Chiến dịch đã tham gia:{" "}
                    {campaignList && campaignList.length !== 0
                      ? campaignList.length
                      : 0}{" "}
                  </Typography>
                  <Divider />
                  <List>
                    {campaignList && campaignList.length !== 0
                      ? campaignList.map((campaign) => {
                          return (
                            <ListItem alignItems="flex-start">
                              <ListItemAvatar>
                                <Icon>bookmarks</Icon>
                              </ListItemAvatar>
                              <ListItemText
                                primary={campaign.name}
                                secondary={
                                  <React.Fragment>
                                    <Typography
                                      style={{
                                        paddingBottom: 15,
                                        fontSize: 16,
                                      }}>
                                      {`Từ ngày: ${datetimeHelper.toFormat(
                                        campaign.startAt,
                                        "YYYY-MM-DD"
                                      )} đến ngày: ${datetimeHelper.toFormat(
                                        campaign.endAt,
                                        "YYYY-MM-DD"
                                      )}`}
                                    </Typography>
                                  </React.Fragment>
                                }
                              />
                            </ListItem>
                          );
                        })
                      : null}
                  </List>
                </Grid>
              </Grid>
              <DialogActions>
                {!this.state.id ? (
                  <Button
                    variant="contained"
                    color="secondary"
                    className={classes.button}
                    type="submit">
                    Thêm danh bạ
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    color="secondary"
                    className={classes.button}
                    type="submit">
                    Thay đổi danh bạ
                  </Button>
                )}
              </DialogActions>
            </FormControl>
          </ValidatorForm>
        </div>
        <Dialog open={this.props.loading} title={<CircularProgress />} />
      </Paper>
    );
  }
}

CreateContact.propTypes = {
  classes: PropTypes.object.isRequired,
};

const styles = (theme) => ({
  root: {
    width: "100%",
  },
  toolbar: {
    paddingLeft: theme.spacing.unit,
    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
  },
  form: {
    width: "100%",
  },
  input: {
    width: "98%",
    marginRight: theme.spacing.unit * 3,
  },
  grid: {
    width: "100%",
    paddingLeft: theme.spacing.unit * 3,
    paddingRight: theme.spacing.unit * 3,
  },
});
const mapStateToProps = (state) => ({
  listIndastry: state.indastry.indastries,
  listStage: state.stage.stages,
  contact: state.contact.contact,
  loading: state.contact.loading,
});

const Indastry = connect(null, indastryAction)(CreateContact);
const Stage = connect(null, stageAction)(Indastry);
CreateContact = connect(mapStateToProps, mapActionsToProps)(Stage);

export default withStyles(styles)(CreateContact);
